<template>
    <div class="container">
        <content-header title="Услуги"/>
        <div class="departments">
            <router-link tag="div" :to="{name: 'departmentDetail', params:{slug: department.slug}}"
                         class="department-item" v-for="department of departmentListing">
                <img :src="department.logo && department.logo.full_size" :alt="department.title">
                <span class="department-title more-detail">
                    {{ department.title }}
                </span>
            </router-link>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../components/layout/ContentHeader";
import {mapActions, mapGetters} from "vuex";

export default {
    components: {
        ContentHeader
    },
    computed: {
        ...mapGetters(["departmentListing"])
    },
    methods: {
        ...mapActions(["fetchDepartmentListing"])
    },
    mounted() {
        this.fetchDepartmentListing();
    }
}
</script>

<style scoped>
.departments {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    grid-gap: 20px;
    margin-top: 40px;
}

.department-item img {
    width: 140px;
    height: 140px;
    cursor: pointer;
    display: block;
    margin: 0 auto;
}

.department-title {
    text-align: center;
    margin: 4px auto;
    font-size: 12px;
    line-height: 10px;
}
</style>
